import { useCallback, useState } from 'react'
const isFunction = (value: unknown): value is Function => typeof value === 'function'

// A patch is any subset of the state (Partial<S> covers every Pick<S, K>);
// null, from a value or a functional update, means "no change".
export type SetState<S extends Record<string, any>> = (
  state: Partial<S> | null | ((prevState: Readonly<S>) => Partial<S> | null)
) => void

const useSetState = <S extends Record<string, any>>(initialState: S | (() => S)): [S, SetState<S>] => {
  const [state, setState] = useState<S>(initialState)

  const setMergeState = useCallback((patch) => {
    setState((prevState) => {
      const newState = isFunction(patch) ? patch(prevState) : patch
      return newState ? { ...prevState, ...newState } : prevState
    })
  }, [])

  return [state, setMergeState]
}

export default useSetState
